// src/pages/landing/TalkToStrangers.jsx
import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { OmegleAlternativeBanner, SROnlyH1 } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function TalkToStrangers() {
  return (
    <>
      <SEO
        title="Talk to Strangers - Omegle Alternative | Talkvee"
        description="Talk to strangers in a safer Omegle alternative. Quick guest login, interest matching, and fun challenges."
        pathname="/talk-to-strangers"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Talk to Strangers", "item": "https://talkvee.com/talk-to-strangers" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <OmegleAlternativeBanner />
        <section className="landing-hero">
          
          <h1 className="landing-title">Talk to Strangers — Safely & Instantly</h1>
          <p className="landing-subtitle">
            A modern Omegle alternative: ad-free, guest login in seconds, match by
            interests, and quick icebreakers to keep conversations flowing.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <FAQSection
          items={[
            {
              q: "Is it safe to talk to strangers on Talkvee?",
              a: "Yes. Inappropriate behavior is reported and banned quickly. We built Talkvee to feel safe and respectful."
            },
            {
              q: "What makes conversations less awkward?",
              a: "Talkvee adds trivia challenges, icebreaker quizzes, and even laugh challenges so you always have something fun to do."
            },
            {
              q: "Do I need to log in?",
              a: "No. Guest login works instantly. Or sign in with Google or Facebook if you want."
            },
            {
              q: "Is Talkvee free to use?",
              a: "Yes. Talkvee is free and doesn’t show ads."
            },
            {
              q: "How do I find people with similar interests?",
              a: "You can enter keywords like 'music' or 'gaming' and we’ll match you with people who entered the same."
            },
            {
              q: "How is Talkvee better than Omegle?",
              a: "Talkvee is modern, lightweight, safer, ad-free, and designed with positive interactions in mind."
            },
            {
              q: "Can I video chat on mobile?",
              a: "Yes. Talkvee works on desktop and mobile, with no extra app required."
            },
            {
              q: "What if someone is rude or inappropriate?",
              a: "Use the report option. Offending users get temporary or permanent bans."
            }
          ]}
        />

      </div>
    </>
  );
}